// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24gZX","newExpiryDate":"styles_newExpiryDate__2vylK","footer":"styles_footer__1CqYn"};